import React, { useEffect, useState } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import { useRestaurant } from '../contexts/RestaurantContext';
import { CFormLabel } from '@coreui/react';
import { useAuth } from '../contexts/AuthContext';

const RestaurantSelection = ({
    className,
    labelClassName,
    isSingleUse = false,
    isUserMode = false,
    multiSelect = true,
    required = false,
    error = false,
    menuPlacement = 'bottom',
    propsRestaurantId,
    setPropsRestaurantId
}) => {
    const requiredIcon = required ? <span className="text-danger">*</span> : null;
    const { getAllRestaurants, selectedRestaurantId, setSelectedRestaurantId, getUserRestaurants } = useRestaurant();
    const { setRestaurantId, restaurantId } = useAuth()

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(50);

    useEffect(() => {
        if (selectedRestaurantId) {
            setRestaurantId(selectedRestaurantId.value);
        }
    }, [selectedRestaurantId]);

    const fetchRestaurants = async (searchValue, loadedOptions, { page }) => {
        try {
            const response = await getUserRestaurants(page, rowsPerPage, 'id', -1, searchValue);
            if (response.totalPages > 0) {
                let newOptions = response.data.map((restaurant) => ({
                    label: restaurant.name,
                    value: restaurant.id,
                }));

                if (isSingleUse && restaurantId) {
                    newOptions = newOptions.filter(option => option.value !== restaurantId);
                }

                return {
                    options: newOptions,
                    hasMore: page !== response.totalPages,
                    additional: {
                        page: page + 1,
                    },
                };
            } else {
                return {
                    options: [],
                    hasMore: false,
                    additional: null,
                };
            }
        } catch (error) {
            console.error('Error fetching restaurants', error);
            return {
                options: [],
                hasMore: false,
                additional: null,
            };
        }
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            whiteSpace: state.isFocused ? 'pre-wrap' : 'nowrap',
            wordBreak: state.isFocused ? 'break-all' : null,
            wordWrap: state.isFocused ? 'break-word' : null,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }),
    };

    return (
        <div className={className}>
            <div className={labelClassName}>
                <CFormLabel>{isSingleUse ? 'Restaurant' : 'Restaurant'} {requiredIcon}</CFormLabel>
            </div>
            <div className='w-100'>
                <AsyncPaginate
                    // menuPortalTarget={document.body}
                    className={`${(error && required) && 'multiSelect_error'}`}
                    value={(isSingleUse || isUserMode) ? propsRestaurantId : selectedRestaurantId}
                    loadOptions={fetchRestaurants}
                    isMulti={multiSelect}
                    closeMenuOnSelect={!multiSelect ? true : false}
                    onChange={(selectedOptions) => (isSingleUse || isUserMode) ? setPropsRestaurantId(selectedOptions) : setSelectedRestaurantId(selectedOptions)}
                    placeholder='Select restaurants...'
                    noOptionsMessage={() => ('No restaurant found')}
                    loadingMessage={() => ('Restaurant Loading...')}
                    loadOptionsOnMenuOpen={true}
                    additional={{
                        page: currentPage,
                    }}
                    SelectProps={{
                        isSearchable: true,
                        removeSelected: false,
                    }}
                    menuPlacement={menuPlacement}
                    // defaultMenuIsOpen={true}
                    menuShouldScrollIntoView={false}
                    // menuPortalTarget={document.querySelector('body')}
                    // styles={{
                    //     ...customStyles,
                    //     menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    // }}
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                        menu:       base => ({ ...base, zIndex: 9999 }),
                    }}
                />
                {(error && required) && <span className="text-danger error_message">{multiSelect ? `Please select one or more restaurant(s)` : 'Please select any one restaurant.'}</span>}
            </div>
        </div>
    );
};

export default RestaurantSelection;